import React, { ChangeEvent, useEffect, useState } from 'react';
import { ModalWithButtons } from '../ModalWithButtons/ModalWithButtons.component';
import { AuthUser } from './AuthUser.component';
import { Grid, TextField } from '@material-ui/core';
import { FormControlLabel } from '@mui/material';
import { IUserProfile } from './IUserProfile.types';
import { validatePhoneNumberInput } from '../../services/validation/validationUser';
import { useStyles } from './EditUserPhone.styles';
import { CheckboxOne } from '../CheckboxOne/CheckboxOne.component';

interface EditUserPhoneProps {
  user?: IUserProfile;
  userId: string;
  open: boolean;
  onClose: () => void;
  onNavBack: () => void;
}

export const EditUserPhone: React.FC<EditUserPhoneProps> = (props) => {
  const classes = useStyles();

  const [phone, setPhone] = useState<string>('');
  const [phoneHidden, setPhoneHidden] = useState<boolean>(true);
  const [validPhone, setValidPhone] = useState<boolean>(true);
  const [openAuthUser, setOpenAuthUser] = useState<boolean>(false);

  const validatePhoneNumber = (phone: string) => {
    if (phone.length === 0) {
      setValidPhone(true);
    } else {
      const isValidatPhoneNumber = validatePhoneNumberInput(phone);
      setValidPhone(isValidatPhoneNumber);
    }
  };

  const handlePhoneFocus = () => {
    if (phone) {
      validatePhoneNumber(phone);
    }
  };

  useEffect(() => {
    if (props.user) {
      setPhoneHidden(props.user.phoneHidden);
      setPhone(props.user.phone);
    }
  }, [props.user]);

  const handleOpenAuthUser = () => {
    setOpenAuthUser(true);
  };

  const handleAuthUserClose = () => {
    setOpenAuthUser(false);
    props.onClose();
  };

  const isUserDataUpdated = (): boolean => {
    if (props.user) {
      return phone !== '' && (phone !== props.user.phone || phoneHidden !== props.user.phoneHidden);
    } else return false;
  };

  const clearInput = () => {
    if (props.user) {
      setPhone(props.user.phone);
    }
    setValidPhone(true);
  };

  const onCancelEdit = () => {
    clearInput();
    props.onClose();
    props.onNavBack();
  };
  const onCloseAuthModal = () => {
    setOpenAuthUser(false);
  }

  return (
    <>
      {props.user && (
        <>
          <ModalWithButtons
            open={props.open}
            size="sm"
            navButtonLabel="Mój profil"
            handleNavBack={onCancelEdit}
            xCloseButton={onCancelEdit}
            autoHeight={true}
            onCancel={onCancelEdit}
            onConfirm={handleOpenAuthUser}
            confirmButtonLabel="Aktualizuj"
            confirmButtonDisabled={!isUserDataUpdated() || !validPhone}
            buttonsContainerStyle={{ marginTop: '120px' }}
          >
            <Grid container className={classes.container}>
              <Grid>
                <div className={classes.modalSubTitle}>Edytuj numer telefonu</div>
              </Grid>
              <Grid item xs={7} className={classes.item}>
                <TextField
                  error={!validPhone}
                  helperText={validPhone ? undefined : 'Podany numer telefonu jest nieprawidłowy'}
                  value={phone}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => setPhone(e.target.value)}
                  onBlur={handlePhoneFocus}
                  id="outlined-textarea"
                  label="Nr telefonu"
                  placeholder="Nr telefonu"
                  variant="outlined"
                  fullWidth={true}
                  inputProps={{
                    style: {
                      padding: '15.5px',
                      color: '#2C2D3E',
                      borderColor: !validPhone ? '#BC0000' : '#2C2D3E',
                    },
                  }}
                  FormHelperTextProps={{
                    style: {
                      margin: '5px',
                      color: '#BC0000',
                    },
                  }}
                  InputLabelProps={{
                    style: { color: !validPhone ? '#BC0000' : '#2C2D3E' },
                  }}
                />
              </Grid>
              <Grid style={{ width: '50%' }}>
                <FormControlLabel
                  control={
                    <CheckboxOne
                      name={'phoneHidden'}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => setPhoneHidden(e.target.checked)}
                      checked={phoneHidden}
                      value={phoneHidden}
                    />
                  }
                  label="Ukryj numer telefonu"
                />
              </Grid>
            </Grid>
          </ModalWithButtons>
          <AuthUser
            open={openAuthUser}
            phone={phone}
            phoneHidden={phoneHidden}
            userId={props.userId}
            onClose={handleAuthUserClose}
            onNavBack={props.onNavBack}
            onEditUserPhoneClose={props.onClose}
            onCloseUpdate={onCancelEdit}
            onCloseXButton={onCloseAuthModal}
          />
        </>
      )}
    </>
  );
};
